const Visibility = (): JSX.Element => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 100 69"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M50 0C27.2727 0 7.86364 14.1364 0 34.0909C7.86364 54.0455 27.2727 68.1818 50 68.1818C72.7273 68.1818 92.1364 54.0455 100 34.0909C92.1364 14.1364 72.7273 0 50 0ZM50 56.8182C37.4545 56.8182 27.2727 46.6364 27.2727 34.0909C27.2727 21.5455 37.4545 11.3636 50 11.3636C62.5455 11.3636 72.7273 21.5455 72.7273 34.0909C72.7273 46.6364 62.5455 56.8182 50 56.8182ZM50 20.4545C42.4545 20.4545 36.3636 26.5455 36.3636 34.0909C36.3636 41.6364 42.4545 47.7273 50 47.7273C57.5455 47.7273 63.6364 41.6364 63.6364 34.0909C63.6364 26.5455 57.5455 20.4545 50 20.4545Z" />
  </svg>
)

export default Visibility
